<div [(ngModel)]="showBaseDevicesOnly" ngDefaultControl class="row">

  @if (countData > 0) {
    <div class="statusBlock" [ngClass]="statusClass">
      <div (click)="displayOnlineStatusDevices()" class="cursorPointer">
        <span class="statusCount" [ngClass]="statusClass">{{countData}}</span>
        <span class="statusHeader"
        [ngClass]="!onlineStatus.state ? '' : 'boldNormalSizeFont'">{{statusTitle}}</span>
        <span [ngClass]="!onlineStatus.state ? 'fa-chevron-down' : 'fa-chevron-up'" class="fa-solid fa-xl"
          style="float: right; color: #707070; position: relative; top: 15px;">
        </span>
        @if (showProductStatus) {
          <div class="onlineStatusDevices">
            <app-device-database></app-device-database>
          </div>
        }
      </div>
      @if (onlineStatus?.state) {
        <div [@animationCollapseLeave]>
          @if (!onlineStatus?.deviceList) {
            <div>
              <img style="margin-top:5px;" class="fadeLoader centerLoader logoSmall" src="assets/img/loading_logo.svg">
            </div>
          }
          @if (onlineStatus?.deviceList) {
            <div style="margin-left: 0px;">
              <div class="d-flex justify-content-between align-items-center ml-1">
                <span style="color: #222222;"> {{description}}</span>
                <span class="btn btn-outline-primary gray-bg cursorPointer text-nowrap" (click)="exportAsCSV()">
                  <span class="fa-light fa-download"></span>
                  {{'DOWNLOAD_CSV' |translate}}
                </span>
              </div>
              <div class="onlineStatusDevices" [@animationCollapse]>
                <div>
                  <table matSort class="table table-hover" (matSortChange)="sortData($event)">
                    <thead>
                      <tr>
                        <th mat-sort-header="id">ID</th>
                        <th mat-sort-header="name" class="col-name">{{'DEVICE_NAME' |translate}}</th>
                        @if (showCustomer) {
                          <th>{{'CUSTOMER' | translate}}</th>
                        }
                        <th mat-sort-header="location">{{'LOCATION' |translate}}</th>
                        <th mat-sort-header="deviceType">{{'DEVICE_TYPE' |translate}}</th>
                        <th mat-sort-header="softwareVersion">{{'DEVICE_SOFTWARE_VERSION'
                        |translate}}</th>
                        <th mat-sort-header="lastcon">{{'DEVICE_LAST_CONTACT' |translate}}</th>
                        @if (statusType === 'Excluded') {
                          <th mat-sort-header="exclusionReason">{{'EXCLUSION_REASON' |translate}}</th>
                        }
                        @if (statusType === 'Excluded' && canExclude) {
                          <th></th>
                        }
                        @if (statusType !== 'Excluded' && canExclude) {
                          <th class="col-exclude text-right">{{'EXCLUDE_DEVICE' |translate}}</th>
                        }
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (dev of onlineStatus?.deviceList; track dev) {
                        <tr (click)="!disableRowClick && openDevice(dev)"
                          [class.cursorPointer]="!disableRowClick">
                          <td>{{dev.id}}</td>
                          <td class="col-name">{{dev.name}}</td>
                          @if (showCustomer) {
                            <td>{{dev.customerName}}</td>
                          }
                          <td>{{dev.locationName}}</td>
                          <td>{{getDeviceType(dev.deviceType)}}</td>
                          <td>{{dev.softwareVersion != 0 ? dev.softwareVersion : '-'}}</td>
                          <td>{{dev.lastConnection |moment:'l LTS'}}</td>
                          @if (statusType === 'Excluded') {
                            <td>{{getExclusionReason(dev.exclusionReason) | translate}}</td>
                          }
                          @if (statusType === 'Excluded' && canExclude) {
                            <td>
                              <span
                                class="fa-solid fa-xmark fa-xl text-danger cursorPointer"
                                title="{{ 'REMOVE_EXCLUSION' | translate }}"
                                (click)="removeExclusion($event, dev)">
                              </span>
                            </td>
                          }
                          @if (statusType !== 'Excluded' && canExclude) {
                            <td class="col-exclude text-right">
                              <button
                                class="btn btn-xs btn-outline-secondary"
                                style="line-height:1; padding: 4px 8px;"
                                title="{{ 'EXCLUDE_DEVICE' | translate }}"
                                (click)="addExclusion($event, dev)">
                                <i class="fa-solid fa-ban"></i>
                              </button>
                            </td>
                          }
                          <td>
                            @if (dev.lowBatteryWarning && dev.lowBatteryLevel < 4) {
                              <div>
                                <span class="fa-solid fa-fw fa-lg"
                                [ngClass]="service.getBatteryClass(dev.lowBatteryLevel)"></span>
                              </div>
                            }
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          }
        </div>
      }
    </div>
  }
  @if (countData === 0) {
    <div class="statusBlockNoClick" [ngClass]="statusClass">
      <span class="statusCount" [ngClass]="statusClass">{{countData}}</span>
      <span class="statusHeader" [ngClass]="!onlineStatus.state ? '' : 'boldNormalSizeFont'">{{statusTitle}}</span>
    </div>
  }
</div>
